import { createContext, useContext } from 'react';
import type { LiteClient } from 'algoliasearch/lite';

export interface SearchClientContextProps {
  autocompleteIndexName: string;
  indexName: string;
  searchClient: LiteClient;
}

const SearchClientContext = createContext<SearchClientContextProps | null>(
  null
);

export const useSearchClient = () => {
  const context = useContext(SearchClientContext);
  if (!context) {
    throw new Error(
      'useSearchClient must be used within a SearchClientProvider'
    );
  }
  return context;
};

export const SearchClientProvider = ({
  children,
  autocompleteIndexName,
  indexName,
  searchClient,
}: React.PropsWithChildren<SearchClientContextProps>) => (
  <SearchClientContext.Provider
    value={{ searchClient, indexName, autocompleteIndexName }}
  >
    {children}
  </SearchClientContext.Provider>
);

export default SearchClientProvider;
